/* istanbul ignore file */
import React from 'react';
import { Show } from 'framework/show';
import { useExpenseService, useExpenseUrl } from 'domain/shared/expense';
import { useExpenseId } from 'domain/finance/expenses/shared/useExpenseId';
import ViewExpensePageContent from './ViewExpensePageContent';
import { SensitiveShowElementLayout } from 'framework/sensitiveData';

const ExpenseViewPage = () => {
  const { getById } = useExpenseService();
  const id = useExpenseId();
  const { getListUrl } = useExpenseUrl();

  return (
    <Show getDataMethod={() => getById(id)}>
      <SensitiveShowElementLayout
        // TODO: Update after updating BE
        loadSensitiveDataMethod={() => Promise.resolve({})}
        sensitiveDataId={id}
        sensitiveDataIdSource="id"
        timerId={getListUrl()}
      >
        <ViewExpensePageContent />
      </SensitiveShowElementLayout>
    </Show>
  );
};

export default ExpenseViewPage;
